import React, { useRef, useState, useEffect } from "react";
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import OverlayContainer from '../ui/OverlayContainer';
import AdminContainer from '../../containers/users/AdminContainer';
import StatisticsContainer from '../../containers/main/StatisticsContainer';
import DatabaseFunctionsContainer from '../../containers/users/DatabaseFunctionsContainer'

function AuthorizationAdmin(props) {
    let navigate = useNavigate()
    let [timeoutMark, setTimeoutMark] = useState(null)
    let [showDeny, setShowDeny] = useState(false)
    let [allowedRoles] = useState(['Builder', 'ClientAdmin', 'IEAdmin'])
    let superRef = useRef(null)

    // trigger on component mount
    useEffect(() => {
        lagRender()
        handleLoginRedirect()
    }, [])

    function lagRender() {
        if (timeoutMark === null && !showDeny) {
            let timeout = setTimeout(flipDeny, 4000);
            setTimeoutMark({ timeout });
        }
    }

    function flipDeny() {
        if (superRef.current !== null) {
            clearTimeout(timeoutMark);
            setShowDeny(true);
            setTimeoutMark(null);
        }
    }

    function handleLoginRedirect() {
        // If user isn't logged in, store the current path and send them to the login screen to be redirected back to once they log in.
        if (!allowedRoles.includes(props.role) && !props.loading && !props.popup && showDeny) {
            const location = {
                pathname: '/',
                state: {
                    from: { pathname: location.pathname }
                }
            }
            navigate(location);
        }            
    }

    function renderMainPage() {
        switch(props.toRender) {
            case 'admin':
              return <AdminContainer />;
            case 'statistics':
                return <StatisticsContainer />;
            case 'functions':
                return <DatabaseFunctionsContainer />;
            default:
              return false;
          }
    }

    // This is the render logic, no need to declare another method is a functional component
    if (allowedRoles.includes(props.role) && !props.loading && !props.popup) {
        return <div className="main" ref={superRef}>{renderMainPage()}</div>;
    } else if (props.loading || props.popup) {
        return (
            <div className="main" ref={superRef}>
                <OverlayContainer {...props} />
                {renderMainPage()}
            </div>
        );
    } else {
        return (showDeny) ? <p ref={superRef} style={{'marginLeft': '100px', 'marginTop': '100px', 'fontSize':"30px"}}>There was an error trying to access this page</p> : null
    }
}

function mapStateToProps(state) {
    return {
        role: state.users.role,
        loading: state.ui.loading,
        loadingMessage: state.ui.loadingMessage,
        popup: state.ui.popup,
    }
}

export default connect(mapStateToProps, null)(AuthorizationAdmin);